<template>
  <v-data-table
    v-if="transaction"
    :headers="tableColumns"
    :items="[transaction]"
    :loading="isLoading"
    :hide-default-footer="true"
    :item-class="() => 'linked-transaction-item'"
  >
    <!-- Amount -->
    <template #[`item.amount`]="{ item }">
      <div>
        {{ formatAmount(item.transactionAmount, item.transactionCurrency) }}
      </div>
    </template>

    <!-- Created At -->
    <template #[`item.createdAt`]="{ item }">
      <div>{{ item.createdAt | dayjs(`${getDateFormat(item.createdAt)}`) }}</div>
    </template>

    <template #[`item.actions`]="{ item }">
      <v-menu bottom left>
        <template #activator="{ on, attrs }">
          <v-btn class="linked-transaction-list-item-show-more-actions" icon v-bind="attrs" v-on="on">
            <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item class="prevent-linked-transaction-item-detail" :to="toTransactionRoute(item)">
            <v-list-item-title>
              <v-icon size="20" class="me-2">
                {{ icons.mdiFileDocumentOutline }}
              </v-icon>
              <span>Details</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import dayjs from 'dayjs';
import Vue from 'vue';
import router from '@/router';
import { getDateFormat } from '@core/utils/filter';
import useLinkedTransaction from './useLinkedTransaction';
import { mdiDotsVertical, mdiFileDocumentOutline } from '@mdi/js';
import { PreventRouteEnum } from '@/enums/prevent-route.enum';

export default {
  name: 'LinkedTransactionList',
  props: {
    internalTransactionId: { type: String, required: true },
    notificationId: { type: String, required: false },
    orderId: { type: String, required: false },
  },
  methods: {
    getDateFormat,
    formatAmount(amount, currency) {
      if (amount == null) return '-';
      if (!currency) return `${amount.toFixed(2)}`;
      return `${amount.toFixed(2)} ${currency}`;
    },
  },
  setup(props) {
    const { isLoading, transaction, tableColumns, fetchTransactionById } = useLinkedTransaction();

    if (props.internalTransactionId) {
      fetchTransactionById(props.internalTransactionId);
    } else {
      Vue.notify({
        type: 'error',
        title: 'Prevent',
        text: 'Cannot fetch linked transaction.',
      });
    }
    const toTransactionRoute = item => {
      const params = { transactionId: item.internalTransactionId || item.id };
      if (props.notificationId) {
        return { name: 'transaction-view', params, query: { from: PreventRouteEnum.Notification, id: props.notificationId } };
      }
      if (props.orderId) {
        return { name: 'transaction-view', params, query: { from: PreventRouteEnum.Order, id: props.orderId } };
      }
      return { name: 'transaction-view', params, query: { from: PreventRouteEnum.Transactions } };
    };

    return {
      router,
      isLoading,
      tableColumns,
      transaction,
      toTransactionRoute,
      today: dayjs().format('YYYY-MM-DD'),
      icons: {
        mdiDotsVertical,
        mdiFileDocumentOutline,
      },
    };
  },
};
</script>
